// extracted by mini-css-extract-plugin
module.exports = {"rightSidebarFooter":"RightSidebarSaveFooter_rightSidebarFooter__8V9g8","leftButton":"RightSidebarSaveFooter_leftButton__1GJ_z"};